// eslint-disable-next-line
import parse, { domToReact } from 'html-react-parser';
import React from 'react';
import TransitionComponent from '../components/transition-component';

const options = {
  // eslint-disable-next-line
  replace: ({ name, attribs, children }: any) => {
    if (!attribs) return null;

    if (attribs.class) {
      const classList = attribs.class.split(' ');

      if (classList.includes('wp-block-image')) {
        return (
          <TransitionComponent rootMargin="20%">
            <div className={attribs.class} dir="auto">
              {domToReact(children, options)}
            </div>
          </TransitionComponent>
        );
      }
    }

    if (name === 'p') {
      let style;
      try {
        style = JSON.parse(attribs.style);
      } catch (e) {
        style = null;
      }
      return (
        <p dir="auto" className={attribs.class} style={style}>
          {domToReact(children, options)}
        </p>
      );
    }

    if (name === 'img') {
      return (
        <img
          alt={attribs.alt}
          src={attribs.src}
          srcSet={attribs.srcset}
          sizes={attribs.sizes}
        />
      );
    }
    if (name === 'br') {
      return <span />; // @TODO: Change to something else
    }
    if (name === 'a' && attribs.href.startsWith('http')
    && !attribs.href.startsWith('https://skindeepmag.com')
    && !attribs.href.startsWith('http://skindeepmag.com')) {
      return (
        <a href={attribs.href} target="_blank" rel="noopener noreferrer">
          {domToReact(children, options)}
        </a>
      );
    }

    return null;
  },
};

export function stripTagsFromText(text: string) {
  return text.replace(/(<([^>]+)>)/ig, '');
}

export function escapeHTMLEntities(text: string) {
  return parse(stripTagsFromText(text)).toString();
}

export default (markup: string) => parse(markup, options);
